// extracted by mini-css-extract-plugin
export default {"container":"NotAllowed_container__NNTmF","title":"NotAllowed_title__tiZ8I","list":"NotAllowed_list__pCOjc","item":"NotAllowed_item__JbnJz"};